module.exports = __webpack_public_path__ + "gym-5a5c54e2a3f1a938515026ef31240437.svg";